import src from "IMAGE";
export default { src, width: 1664, height: 268, blurWidth: 0, blurHeight: 0};
